import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { needsConsentPrompt, onConsentChange, setConsent, trackingDisabled } from '../lib/analytics';

// Cookie choice for ad/analytics tags (Google, Meta). Reopen from anywhere with
// window.dispatchEvent(new Event('bcm:consent-open')) — the footer's "Cookie settings" link does.
const ConsentBanner = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // After mount only: prerendered HTML must not contain the banner (hydration).
    const sync = () => setOpen(needsConsentPrompt() && !trackingDisabled());
    sync();
    const reopen = () => setOpen(true);
    window.addEventListener('bcm:consent-open', reopen);
    const off = onConsentChange(sync);
    return () => { off(); window.removeEventListener('bcm:consent-open', reopen); };
  }, []);

  if (!open || pathname.startsWith('/admin')) return null;

  const choose = (granted) => { setConsent(granted); setOpen(false); };

  return (
    <div role="dialog" aria-live="polite" aria-label="Cookie preferences"
      className="fixed inset-x-3 bottom-3 z-[60] sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-md bg-zinc-950 text-white rounded-2xl shadow-2xl ring-1 ring-white/10 p-5">
      <p className="text-sm leading-relaxed text-zinc-200">
        We use cookies from Google and Meta to see which ads bring you here and to show you vehicles you might like.
        Basic, anonymous site stats are always on. <Link to="/privacy-policy" className="underline hover:text-white">Privacy policy</Link>
      </p>
      <div className="mt-4 flex gap-2">
        <button type="button" onClick={() => choose(true)}
          className="flex-1 rounded-full bg-red-600 hover:bg-red-700 px-4 py-2.5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white">
          Accept
        </button>
        <button type="button" onClick={() => choose(false)}
          className="flex-1 rounded-full bg-white/10 hover:bg-white/20 px-4 py-2.5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white">
          Decline
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;
